'use strict';

goog.provide("Ntry.CpartyCarResult_2016");

goog.require("Ntry.STATIC");
goog.require("Ntry.Engine");

Ntry.CpartyCarResult_2016 = function() {
    this._view = Ntry.interfaceManager.getDom('ntryResultArea');
    this.createDom();
};

(function(p){

    p.createDom = function () {
        var that = this;
        var parent = this._view;
        var ce = Ntry.createElement;
        var container = ce('div', parent, null, 'ntryResultContainer');
        var title = ce('div', container, null, 'ntryResultTitle')
        this._closeButton = ce('span', title, null, 'ntryResultCloseButton');
        this._closeButton.innerHTML = Lang.Menus.close;

        var content = ce('div', container, null, 'ntryResultContent');
        this._leftImg = ce('div', content, null, 'ntryResultLeftImg');

        var rightDiv = ce('div', content, null, 'ntryResultRightDiv');
        this._successContent = ce('div', rightDiv, null, 'ntryResultRightContent');

        this._usedBlockPrefix = ce('span', this._successContent, null, 'ntryResultContentSpan');
        // this._usedBlockCnt = ce('span', this._successContent, null, 'ntryResultBlockCnt');
        this._usedBlockSuffix = ce('span', this._successContent, null, 'ntryResultContentSpan');

        this._limitBlockPrefix = ce('span', this._successContent, null, 'ntryResultContentSpan');
        // this._limitBlockCnt = ce('span', this._successContent, null, 'ntryResultBlockCnt');
        this._limitBlockSuffix = ce('span', this._successContent, null, 'ntryResultContentSpan');

        this._certDiv = ce('div', this._successContent, null, 'cpartyCarResultCertDiv', 'ntryRemove');

        this._certDivLeft = ce('div', this._certDiv, null, 'ntryResultCertDivLeft');

        this._certNameLabel = ce('span', this._certDivLeft, null, 'ntryResultContentNameLabel');
        this._certNameLabel.innerHTML = Lang.Menus.jr_whats_ur_name;

        this._certNameInput = ce('input', this._certDivLeft, null, 'ntryResultContentNameInput');
        this._certNameInput.type = "text";

        this._certLink = ce('div', this._certDiv, null, 'ntryResultContentCert');
        this._certLink.innerHTML = Lang.Menus.jr_down_cert;

        this._failContent = ce('div', rightDiv, null, 'ntryResultRightContent');
        this._failCauseString = ce('span', this._failContent, null, 'ntryResultFailCauseSpan');

        this._essentialBlocks = ce('div', this._failContent, null, 'ntryResultEssentialBlocks');

        this._replayButton = ce('span', content, null, 'ntryResultReplayButton');
        this._replayButton.innerHTML = Lang.Menus.replay;

        this._nextButton = ce('span', content, null, 'ntryResultNextButton');
        this._nextButton.innerHTML = Lang.Menus.go_to_next_level;
        this._nextButton.bindOnClick(function() {
            Ntry.setSkipLevelLimitCheck();
            window.location.href = that._nextLink;
        });
    };

    p.update = function() {
    };

    p.randomString = function(len) {
        var charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var randomString = '';
        for (var i = 0; i < len; i++) {
            var randomPoz = Math.floor(Math.random() * charSet.length);
            randomString += charSet.substring(randomPoz,randomPoz+1);
        }
        return randomString;
    };

    p.loadConfig = function () {
        Ntry.addEventListener("complete", this, this.complete);
        Ntry.addEventListener("showCert", this, this.showCert);
    };

    p.showCert = function(mode) {
        this._failContent.ntryRemove();
        this._replayButton.ntryRemove();
        this._certDiv.ntryShow();
        this._nextButton.ntryRemove();
        this._successContent.ntryShow();
        $(this._certDiv).show();
        $(this._successContent).css('margin-top', '20px');

        this._usedBlockPrefix.innerHTML = "";

        this._leftImg.removeClasses();

        this._leftImg.addClass('ntryResultLeftImg');

        if (mode == 3){
            this._leftImg.addClass('ntryResultSuccess1Img');
        } else if (mode == 4){
            this._leftImg.addClass('cpartyCarResultSuccess4Img');
        }

        var self = this;
        this._closeButton.bindOnClick(function() {
            $(self._view).css('display', 'none');
            $(self._certDiv).css('display', 'none');
        });

        this._replayButton.bindOnClick(function() {
            Ntry.dispatchEvent("replay");
            $(self._view).css('display', 'none');
        });

        this._certLink.rebindOnClick(function() {
            var username = self._certNameInput.value;
            if (username === '') {
                alert(Lang.Users.name_not_empty);
                self._certNameInput.focus();
            } else if(window.cpartyuserkey) {
                window.location.href = '/codingparty/2016#!/certificate/'+window.cpartyuserkey+'/'+username +'/'+mode;
            }
        });

        $(this._view).css('display', 'block');

    };

    p.initState = function(){
        this._replayButton.removeClass('ntryResultReplayButtonFailed');
        this._replayButton.removeClass('ntryResultFailAndReply');
        this._replayButton.removeClass('codingpartyResultCertReplay');
    };

    p.complete = function(success, cause) {

        var stageId = Ntry.configManager.getConfig("stageId");
        if (stageId)
            stageId = Number(stageId);

        this._leftImg.removeClasses();

        this._leftImg.addClass('ntryResultLeftImg');

        var self = this;
        this._closeButton.bindOnClick(function() {
            $(self._view).css('display', 'none');
        });

        this._replayButton.bindOnClick(function() {
            Ntry.dispatchEvent("replay");
            $(self._view).css('display', 'none');
        });

        mode = 3 + parseInt((stageId-1) / 10);
        if(mode == 4)
            stageId = stageId-10;

        this._nextLink = '/codingparty/2016#!/' + mode + '/' +(stageId+1);

        this._certLink.rebindOnClick(function() {
            var username = self._certNameInput.value;
            if (username === '') {
                alert(Lang.Menus.cparty_insert_name);
                self._certNameInput.focus();
            } else {
                window.location.href = '/codingparty/2016#!/certificate/'+window.cpartyuserkey+'/'+username +'/' + mode;
            }
        });

        if(mode == 3) {
            if (success) {
                var isEssentialUsed = this.inspectEssential();
                if (isEssentialUsed) {
                    this.success(stageId);
                    Ntry.dispatchEvent('saveLogs', 'finish');
                } else {
                    this.fail(stageId, Ntry.STATIC.ESSENTIAL_REQUIRED);
                }
            } else {
                this.fail(stageId, cause);
            }

        } else if(mode == 4) {
            if (success) {
                var isEssentialUsed = this.inspectCodeEssential();
                if (isEssentialUsed) {
                    this.Codesuccess(stageId);
                    Ntry.dispatchEvent('saveLogs', 'finish');
                } else {
                    this.fail(stageId, Ntry.STATIC.ESSENTIAL_REQUIRED);
                }
            } else {
                this.fail(stageId, cause);
            }
        } else {
            return ;
        }


        $(this._view).css('display', 'block');
    };

    function getUserCode() {
        var entities = Ntry.entityManager.
                getEntitiesByComponent(Ntry.STATIC.CODE);

        var entity = entities[Object.keys(entities)[0]];

        if (entity)
            return Ntry.entityManager.getComponent(
                entity.id, Ntry.STATIC.CODE).code;
    };

    p.inspectCodeEssential = function() {
        var essentialBlock =
            Ntry.configManager.getConfig('essentialBlockInfo');

        if (essentialBlock === undefined) return true;

        var esBlocks = essentialBlock.blocks.slice(0);

        var code = getUserCode();
        if (_.isEmpty(code)) return false;

        var thread = code.getEventMap('start')[0].getThread();
        if (_.isEmpty(thread)) return false;

        var blocks = thread.getBlockList();

        var index = -1;
        for (var i=0; i<blocks.length; i++) {
            index = esBlocks.indexOf(blocks[i].type);
            if (index > -1) esBlocks.splice(index, 1);

            if (esBlocks.length === 0) return true;
        }
        return false;
    };

    p.getBlockNameInLoop = function(block) {
        var data = block._toJSON().values.STATEMENT._data;
        var ary = [];
        for(var i=0; i< data.length; i++) {
            ary.push(data[i]._toJSON().type);
        }

        return ary;
    }

    p.inspectEssential = function() {
        var essentialBlockInfo = Ntry.configManager.getConfig('essentialBlockInfo');
        if (_.isEmpty(essentialBlockInfo)) return true;

        var entityManager = Ntry.entityManager;
        var entities = entityManager.getEntitiesByComponent(Ntry.STATIC.SCRIPT_CONTAINER);
        if (_.isEmpty(entities)) return false;

        var restoreComp = entityManager.getComponent(_.first(_.keys(entities)),
                    Ntry.STATIC.RESTORE);
        if (!restoreComp) return true;

        var restoreScript = Blockly.mainWorkspace.getTopBlocks(Blockly.mainWorkspace);
        if (!restoreScript) return true;

        var blocks = _.filter(restoreScript, function(b){
            var type = b.type;
            var headBlocks = [
                'ai_start',
                'ai_start_un',
                'maze_step_start',
                'maze_step_unstart',
                'maze_define_unfunction',
                'maze_define_function'
            ];
            return headBlocks.indexOf(type) > -1;
        });

        restoreScript = _.reduce(blocks, function(a,b){
            var txt = Blockly.Xml.domToText(Blockly.Xml.blockToDom_(b));
            return a + txt;
        }, '');

        /* inspect all essentialBlocks pass regex for
         * restore block script
        */
        var matchCnt = 0;
        for (var i=0,len=essentialBlockInfo.blocks.length; i<len; i++) {
            if (new RegExp(essentialBlockInfo.blocks[i], 'i').test(restoreScript))
                matchCnt++;
        };

        return matchCnt >= essentialBlockInfo.matchCnt;
    };

    p.success = function(stageId) {
        var limitBlockCnt = Ntry.configManager.getConfig("limitBlockCnt");
        var usedBlockCnt;
        var stageId = Ntry.configManager.getConfig("stageId");
        if (stageId)
            stageId = Number(stageId);

        if (stageId <= 10) {
            this._leftImg.addClass('ntryResultSuccess1Img');
            this._leftImg.addClass(Lang.type);
            usedBlockCnt = Ntry.countUsedBlocks();
        }

        // this._replayButton.removeClasses();

        this._replayButton.removeClass('ntryResultReplayButtonFailed');
        this._replayButton.removeClass('ntryResultFailAndReply');

        if (stageId === 10){
           // this._replayButton.addClass('ntryResultFailAndReply');
            this._replayButton.addClass('codingpartyResultCertReplay');
            $(this._replayButton).css('bottom', '22px');
        }
        else
            // this._replayButton.addClass('ntryResultReplayButton');
           this._replayButton.addClass("ntryResultReplayButtonFailed");

        // this._usedBlockCnt.innerHTML = usedBlockCnt;
        // this._limitBlockCnt.innerHTML = limitBlockCnt;
        if (usedBlockCnt === limitBlockCnt) {
            if (stageId === 10){
                this._usedBlockPrefix.innerHTML = "";
                this._usedBlockSuffix.innerHTML = Lang.Menus.cparty_result_success_3;
            }
            else
                this._usedBlockPrefix.innerHTML = Lang.Menus.cparty_result_success_1;

        } else if (usedBlockCnt < limitBlockCnt) {
            this._usedBlockPrefix.innerHTML = Lang.Menus.cparty_result_success_1;
        } else {
            this._usedBlockSuffix.innerHTML = "";
            this._usedBlockPrefix.innerHTML = Lang.Menus.cparty_result_success_2;
        }

        if (stageId === 10) {
            this._certDiv.ntryShow();
            $(this._certDiv).show();
            this._nextButton.ntryRemove();
        } else {
            this._nextButton.ntryShow();
        }

        var playerData = CPartyData.player[stageId];
        var script = Blockly.Xml.workspaceToDom(Blockly.mainWorkspace)
        playerData.userScript = Blockly.Xml.domToText(script);
        this._successContent.ntryShow();
        this._replayButton.ntryShow();
        this._failContent.ntryRemove();

        if (window.cpartyuserkey) {
            Ntry.dispatchEvent("addActivityLog", stageId, {
                name: 'finish'
            });
        }
    };

    p.currentUsedBlock = function() {
        var code = getUserCode();

        if (code)
            return code.getEventMap('start')[0]
                .getThread().countBlock()-1;
    };

    p.fail = function(stageId, cause) {
        var theme = 1;

        var stageId = Ntry.configManager.getConfig("stageId");
        if (stageId) {
            stageId = Number(stageId);
        }

        if (stageId <= 10)
            theme = 1;
        else if (stageId <= 20 && stageId > 10)
            theme = 4;

        var causeString = '';
        var causeStyle = 1;

        var causeMsgs = [
            Lang.Menus.cparty_result_fail_1,
            Lang.Menus.cparty_result_fail_2,
            Lang.Menus.cparty_result_fail_3,
            Lang.Menus.cparty_result_fail_4,
            Lang.Menus.cparty_result_fail_5
        ];

        this._essentialBlocks.removeClasses();
        this._essentialBlocks.ntryRemove();

        switch (cause) {
            case Ntry.STATIC.SIMOOROOK:
                causeString = causeMsgs[3];
                causeStyle = 1;
                break;

            case Ntry.STATIC.WALL_CRASH:
                causeString = causeMsgs[0];
                causeStyle = 2;
                break;

            case Ntry.STATIC.BEE_ATTACK:
                causeString = causeMsgs[1];
                causeStyle = 3;
                break;

            case Ntry.STATIC.ELECTRIC_SHOCK:
                causeString = causeMsgs[1];
                causeStyle = 3;
                break;

            case Ntry.STATIC.SLIP:
                causeString = causeMsgs[1];
                causeStyle = 3;
                break;
            case Ntry.STATIC.ESSENTIAL_REQUIRED:
                causeString = causeMsgs[2];
                causeStyle = 1;
                this.renderBlocks(stageId , true);
                break;
            case Ntry.STATIC.GO_SLOW_CRASH:
                causeString = causeMsgs[4];
                causeStyle = 4;
                this.renderBlocks(stageId);
                break;
            default:
                causeString = causeMsgs[3];
                causeStyle = 1;

        }

        var imageClass = 'ntryResultFail_'+theme+'_'+causeStyle;

        this._leftImg.addClass(imageClass);
        this._failCauseString.innerHTML = causeString;

        this._successContent.ntryRemove();
        this._failContent.ntryShow();

        this._nextButton.ntryRemove();
        this._replayButton.removeClasses();
        this._replayButton.addClass("ntryResultFailAndReply");
        var stageId = Ntry.configManager.getConfig("stageId");
        if (stageId)
            stageId = Number(stageId);
        mode = 3 + parseInt((stageId-1) / 10);
        if (mode == 4 && Entry.commander) {
            Entry.commander.report(
                null,
                [
                    'fail',
                    ['cause', cause],
                    ['code', getUserCode().stringify()]
                ]);
        }
    };

    p.renderBlocks = function(stageId , isEssential) {
        if(isEssential) {
            if(stageId > 10) {
                stageId = stageId %10;
                switch (stageId) {
                    case 4:
                    case 5:
                        type=7;
                    break;
                    case 6:
                    case 7:
                        type=8;
                    break;
                    case 8:
                        type=9;
                    break;
                    case 9:
                    case 10:
                        type=10;
                    break;
                }
            } else
                type = 5;
        } else {
            type = 6;
        }
        this._essentialBlocks.removeClasses();
        this._essentialBlocks.addClass("cpartyResultEssentialBlocks");
        this._essentialBlocks.addClass("cpartyResultEssentialBlock_"+type);
        this._essentialBlocks.addClass(Lang.type);
    };

    p.currentUsedBlock = function() {
        var code = getUserCode();

        if (code)
            return code.getEventMap('start')[0]
                .getThread().countBlock()-1;
    };

    p.Codesuccess = function(stageId) {
        var playerData = CPartyData.player[10 + stageId];
        var code = getUserCode().stringify();
        playerData.userCode = code;
        if (Entry.commander) {
            Entry.commander.report(
                null,
                [
                    'success',
                    ['code', code]
                ]);
        }
        Ntry.dispatchEvent("jrActivityStageFinish", stageId);
        var limitBlockCnt = Ntry.configManager.getConfig("limitBlockCnt");
        var usedBlockCnt = this.currentUsedBlock();
        this._leftImg.addClass('cpartyCarResultSuccess4Img');

        this._replayButton.removeClass('ntryResultReplayButtonFailed');
        this._replayButton.removeClass('ntryResultFailAndReply');

        if (stageId === 10) {
           this._replayButton.addClass('codingpartyResultCertReplay');
        } else {
           this._replayButton.addClass("ntryResultReplayButtonFailed");
        }

        var usedPrefix = this._usedBlockPrefix
        var menuLang = Lang.Menus;
        if (usedBlockCnt <= limitBlockCnt) {
            if (stageId != 10)
                usedPrefix.innerHTML = menuLang.cparty_car_popup_prefix_1;
            else
                usedPrefix.innerHTML = menuLang.cparty_car_popup_suffix;
        } else if (usedBlockCnt > limitBlockCnt)
            usedPrefix.innerHTML = menuLang.cparty_car_popup_prefix_2;

        var nextBtn = this._nextButton;
        if (stageId === 10) {
            this._certDiv.ntryShow();
            $(this._certDiv).show();
            nextBtn.ntryRemove();
            this._replayButton.ntryRemove();
        } else {
            nextBtn.ntryShow();
        }
        this._successContent.ntryShow();
        this._replayButton.ntryShow();
        this._failContent.ntryRemove();
    };

})(Ntry.CpartyCarResult_2016.prototype);
